var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionMarkModalBackground = function SvgQuestionMarkModalBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 316,
    viewBox: "0 0 364 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_99039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0801 200.372C44.7328 195.954 54.5182 198.576 58.9365 206.228L111.192 296.738C115.611 304.39 112.989 314.176 105.336 318.594L5.98802 375.953C-1.66466 380.371 -11.4501 377.749 -15.8684 370.096L-68.1241 279.587C-72.5424 271.934 -69.9204 262.149 -62.2677 257.73L37.0801 200.372Z",
    fill: "url(#paint0_linear_2090_99039)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.697,
    y: 134,
    width: 13.7133,
    height: 66.6236,
    rx: 4,
    transform: "rotate(60 395.697 134)",
    fill: "#FEB45E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2090_99039",
    x1: 85.0644,
    y1: 251.483,
    x2: -41.9963,
    y2: 324.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_99039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 364,
    height: 316,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarkModalBackground);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzY0IiBoZWlnaHQ9IjMxNiIgdmlld0JveD0iMCAwIDM2NCAzMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yMDkwXzk5MDM5KSI+CjxwYXRoIGQ9Ik0zNy4wODAxIDIwMC4zNzJDNDQuNzMyOCAxOTUuOTU0IDU0LjUxODIgMTk4LjU3NiA1OC45MzY1IDIwNi4yMjhMMTExLjE5MiAyOTYuNzM4QzExNS42MTEgMzA0LjM5IDExMi45ODkgMzE0LjE3NiAxMDUuMzM2IDMxOC41OTRMNS45ODgwMiAzNzUuOTUzQy0xLjY2NDY2IDM4MC4zNzEgLTExLjQ1MDEgMzc3Ljc0OSAtMTUuODY4NCAzNzAuMDk2TC02OC4xMjQxIDI3OS41ODdDLTcyLjU0MjQgMjcxLjkzNCAtNjkuOTIwNCAyNjIuMTQ5IC02Mi4yNjc3IDI1Ny43M0wzNy4wODAxIDIwMC4zNzJaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMjA5MF85OTAzOSkiLz4KPHJlY3QgeD0iMzk1LjY5NyIgeT0iMTM0IiB3aWR0aD0iMTMuNzEzMyIgaGVpZ2h0PSI2Ni42MjM2IiByeD0iNCIgdHJhbnNmb3JtPSJyb3RhdGUoNjAgMzk1LjY5NyAxMzQpIiBmaWxsPSIjRkVCNDVFIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yMDkwXzk5MDM5IiB4MT0iODUuMDY0NCIgeTE9IjI1MS40ODMiIHgyPSItNDEuOTk2MyIgeTI9IjMyNC44NDEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0YxRjJGRSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAuMjUiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yMDkwXzk5MDM5Ij4KPHJlY3Qgd2lkdGg9IjM2NCIgaGVpZ2h0PSIzMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";